// src/services/tokenStore.js

const KEY = "auth:accessToken";
let inMemoryToken = null;
let revision = 0;

export const tokenStore = {
    getRevision() { return revision; },
    get() {
        // при первом вызове после перезагрузки попробуем достать из sessionStorage
        if (inMemoryToken) return inMemoryToken;

        if (typeof window === "undefined") {
            return inMemoryToken;
        }

        try {
            const t = window.sessionStorage.getItem(KEY);
            inMemoryToken = t;
            return t;
        } catch {
            return inMemoryToken;
        }
    },

    set(t) {
        revision += 1;
        inMemoryToken = t || null;

        if (typeof window === "undefined") return;

        try {
            if (t) {
                window.sessionStorage.setItem(KEY, t);
            } else {
                window.sessionStorage.removeItem(KEY);
            }
        } catch {
            // если sessionStorage недоступен (инкогнито/ограничения), просто живём на inMemory
        }
    },

    clear() {
        this.set(null);
    },
};
